'use client';

import * as Sentry from '@sentry/nextjs';
import { useReportWebVitals } from 'next/web-vitals';

import { isBot } from '@/utils/isBot';

const CLS_NEEDS_IMPROVEMENT_THRESHOLD = 0.1;
const CLS_GUARD_SAMPLE = 0.1;
const LCP_NEEDS_IMPROVEMENT_THRESHOLD = 2500;
const DEFAULT_LCP_GUARD_SAMPLE = 0.1;

function parseLcpGuardSample(): number {
  const raw = process.env.NEXT_PUBLIC_LCP_GUARD_SAMPLE;
  if (raw === undefined || raw === null) {
    return DEFAULT_LCP_GUARD_SAMPLE;
  }
  const parsed = parseFloat(raw);
  if (isNaN(parsed)) {
    return DEFAULT_LCP_GUARD_SAMPLE;
  }

  return parsed;
}

export const WebVitalsReporter = () => {
  useReportWebVitals((metric) => {
    if (
      metric.name !== 'CLS' ||
      metric.value < CLS_NEEDS_IMPROVEMENT_THRESHOLD ||
      isBot()
    ) {
      return;
    }

    if (Math.random() >= CLS_GUARD_SAMPLE) {
      return;
    }

    Sentry.captureMessage(`CLS 임계 초과: ${metric.value.toFixed(3)}`, {
      level: 'warning',
      tags: {
        webVital: 'CLS',
        route: window.location.pathname,
      },
      extra: {
        value: metric.value,
        metricId: metric.id,
      },
    });
  });

  useReportWebVitals((metric) => {
    if (metric.name !== 'LCP') {
      return;
    }
    if (metric.value < LCP_NEEDS_IMPROVEMENT_THRESHOLD) {
      return;
    }
    if (isBot()) {
      return;
    }

    const sampleRate = parseLcpGuardSample();
    if (sampleRate === 0) {
      return;
    }
    if (Math.random() >= sampleRate) {
      return;
    }

    Sentry.captureMessage(
      `LCP 임계 초과: ${(metric.value / 1000).toFixed(2)}s`,
      {
        level: 'warning',
        tags: {
          webVital: 'LCP',
          route: window.location.pathname,
        },
        extra: {
          value: metric.value,
          metricId: metric.id,
        },
      },
    );
  });

  return null;
};
